import { useSelector } from "react-redux";
import { getCurrencyNumberOfDigits } from "../services/helpers/customization-helper";
import { truncateToDecimals } from "../services/helpers/number-formatter";
import translate from "../services/translation/lang";

export default function Header() {

  const turboMode = useSelector((state) => state.turboMode);
  const { balance } = useSelector((s) => s.balance);
  const decimalPlaces = getCurrencyNumberOfDigits() ?? 2;
  const truncatedBalance = truncateToDecimals(balance, decimalPlaces);
  const login = useSelector((state) => state.login);

  const logo = "img/logo.png";
  return (
    <div className="header">
      <img className="logo" src={logo} alt="by-elbet" />

      <div className="header-balance-holder">
       <div className="header-balance-title text-capitalize">{translate("balance")}</div>
          <div className="balance-holder">
            <div className="currency-symbol">
              {/* <Currency>{login.CurrencyID}</Currency> */}
              {login?.CurrencyID}
            </div>
            <div className="balance-value">{truncatedBalance.toFixed(decimalPlaces)}</div>
          </div>
      </div>
      <div className="header-balance-holder">
       <div className="header-balance-title ">{translate("turbo_balance")}</div>
          <div className="balance-holder">
            <div className="currency-symbol">
              {/* <Currency>{login.CurrencyID}</Currency> */}
              {login?.CurrencyID}
            </div>
            <div className="balance-value">{turboMode.value?.toFixed(decimalPlaces)}</div>
          </div>
      </div>

    </div>
  );
}
